/* a-sk-presale: przedsprzedaż na sklejkach (kierunek B, makieta Kamila 01.11.2026; sekcja sections/hm-sk-presale.liquid).
   - Linie pod przyciskiem: render w sekcji presale, przeniesione pod [data-buy-err] sekcji hm-ef-buy (robi to od razu skrypt
     w sekcji; tu powtórka na wypadek edytora motywu).
   - Arkusz <dialog id="why-december">: otwiera link [data-ps-open], pasek partii (.batch), adres #why-december oraz RAZ po powrocie
     z kasy: klik w główny [data-hm-buy] (także przez sticky i offer, które go klikają) zapisuje w sessionStorage znacznik
     „ścieżka|czas”; na pageshow (także z bfcache) przy znaczniku tej strony i bez znacznika „pokazano” arkusz otwiera się raz,
     a znacznik jest czyszczony. Każdy dostęp do storage w try/catch; bez storage arkusz otwiera się tylko z linku.
   - Przycisk arkusza zamyka arkusz (zdejmuje jego wpis historii, żeby po powrocie z kasy nie było martwego „wstecz”) i klika
     istniejący [data-hm-buy]: ten sam plan, ilość, selling plan i przejście do kasy (własnego koszyka tu nie ma).
     Etykieta = tekst głównego przycisku (textContent), odświeżana po hm:plan.
   - Karta subskrypcji: następne obciążenie = dziś + interwał planu z nazwy planu („Every 8 weeks”), tylko przy subskrypcji.
   - Dostępność: dialog modalny, fokus na tytuł, Esc / Wstecz / tło / ✕ / „Back to the page” / przeciągnięcie w dół zamykają,
     fokus wraca, blokada przewijania tła bez skoku, prefers-reduced-motion. Bez wstawiania kodu HTML: hidden, klasy, atrybuty, textContent. */
(function () {
  if (window.HMPS) return;
  var GO = 'hmPsGo', SHOWN = 'hmPsShown', FRESH = 3 * 3600 * 1000, WK = /(\d+)\s*-?\s*weeks?\b/i;
  var RM = !!(window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches);
  var dlg = null, card, title, body, buyBtn, buyLbl, sub, cfg = { sub: false, plans: [] }, WEEKS = {};
  var lastFocus = null, closing = false, pushed = false, fromPop = false, locked = false, lockY = 0, drag = null, buyAfterPop = false;

  function store(fn) { try { return fn(window.sessionStorage); } catch (e) { return null; } }
  function track(n) { try { if (typeof window.clarity === 'function') window.clarity('event', n); } catch (e) {} }
  function hero() { return document.querySelector('[data-hm-buy-section]'); }
  function mainBtn() { var r = hero(); return r ? r.querySelector('[data-hm-buy]') : null; }
  function q(sel) { return dlg ? dlg.querySelector(sel) : null; }
  function txt(sel, v) { var el = q(sel); if (el) el.textContent = v; }

  function placeLines() {
    var all = [].slice.call(document.querySelectorAll('[data-ps-lines]')), r = hero(), err = r && r.querySelector('[data-buy-err]');
    if (!err) return;
    var fresh = all.filter(function (l) { return !l.hasAttribute('data-ps-moved'); })[0];
    if (fresh) { // nowy render sekcji (edytor): stare przeniesione linie wychodzą
      all.forEach(function (l) { if (l !== fresh) l.remove(); });
      err.parentNode.insertBefore(fresh, err.nextSibling);
      fresh.setAttribute('data-ps-moved', '');
      fresh.hidden = false;
    }
  }

  // iOS Safari omija overflow:hidden: body fixed + zapis i przywrócenie scrollY (wzorzec hm-drawer.js)
  function lock() {
    if (locked) return; locked = true; lockY = window.scrollY;
    var b = document.body.style; b.position = 'fixed'; b.top = (-lockY) + 'px'; b.left = '0'; b.right = '0'; b.width = '100%';
  }
  function unlock() {
    if (!locked) return; locked = false;
    var b = document.body.style; b.position = ''; b.top = ''; b.left = ''; b.right = ''; b.width = '';
    try { window.scrollTo({ top: lockY, left: 0, behavior: 'instant' }); } catch (e) { window.scrollTo(0, lockY); }
  }

  function syncPlan() {
    if (!dlg) return;
    var b = mainBtn(), src = b && b.querySelector('[data-buy-label]');
    if (src && buyLbl) { // tekst głównego przycisku; przekreślona cena (s.btn-was) osobno, jak w hm-ef-buy.js
      var t = '', was = '';
      [].forEach.call(src.childNodes, function (n) {
        if (n.nodeType === 1 && n.classList.contains('btn-was')) was = n.textContent; else t += n.textContent;
      });
      buyLbl.textContent = t.replace(/\s+/g, ' ').trim();
      if (was) {
        buyLbl.appendChild(document.createTextNode(' '));
        var s = document.createElement('s'); s.className = 'ps-was'; s.textContent = was; buyLbl.appendChild(s);
      }
    }
    if (b && buyBtn) {
      if (b.getAttribute('aria-disabled') === 'true' && !b.hasAttribute('data-off')) buyBtn.setAttribute('aria-disabled', 'true');
      else buyBtn.removeAttribute('aria-disabled');
    }
    var r = hero(), c = r && r.querySelector('input[name=hm_plan]:checked'), w = (c && c.dataset.plan) ? (WEEKS[c.dataset.plan] || 0) : 0;
    if (sub) {
      sub.hidden = !(cfg.sub && w);
      if (w) {
        var d = new Date(); d.setHours(12, 0, 0, 0); d.setDate(d.getDate() + w * 7);
        txt('[data-ps-date]', d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' }));
        txt('[data-ps-weeks]', String(w));
        txt('[data-ps-cal-m]', d.toLocaleDateString('en-US', { month: 'short' }));
        txt('[data-ps-cal-d]', String(d.getDate()));
      }
    }
  }

  function buy() { // istniejący mechanizm hm-ef-buy.js: GET /cart.js → linie produktu do zera → add z ilością i planem → /checkout
    buyAfterPop = false;
    var b = mainBtn(); if (b) b.click();
  }
  function finish() {
    if (!dlg) return;
    dlg.classList.remove('is-open'); card.style.transform = '';
    if (dlg.open) dlg.close();
    unlock(); closing = false;
    if (lastFocus && lastFocus.focus && document.contains(lastFocus)) { try { lastFocus.focus({ preventScroll: true }); } catch (e) {} }
  }
  function close() {
    if (!dlg || !dlg.open || closing) return;
    closing = true; dlg.classList.remove('is-open'); track('ps_close');
    if (card.style.transform) card.style.transform = 'translateY(100%)';
    if (RM) finish(); else setTimeout(finish, 300);
  }
  function open(src) {
    if (!init() || dlg.open) return;
    lastFocus = document.activeElement; closing = false;
    syncPlan();
    try { history.pushState({ hmPs: 1 }, ''); pushed = true; } catch (e) { pushed = false; } // Wstecz zamyka arkusz
    lock();
    try { dlg.showModal(); } catch (e) { dlg.setAttribute('open', ''); }
    if (body) body.scrollTop = 0;
    if (RM) dlg.classList.add('is-open');
    else requestAnimationFrame(function () { requestAnimationFrame(function () { dlg.classList.add('is-open'); }); });
    try { title.focus({ preventScroll: true }); } catch (e) {}
    store(function (s) { s.setItem(SHOWN, '1'); });
    track('ps_open_' + src);
  }

  function init() {
    var d = document.querySelector('dialog[data-ps]');
    if (!d) return false;
    if (d === dlg) return true;
    dlg = d; closing = false;
    card = q('.ps-card'); title = q('[data-ps-title]'); body = q('.ps-body');
    buyBtn = q('[data-ps-buy]'); buyLbl = q('[data-ps-buy-label]'); sub = q('[data-ps-sub]');
    try { cfg = JSON.parse(q('[data-ps-config]').textContent) || cfg; } catch (e) {}
    WEEKS = {};
    (cfg.plans || []).forEach(function (p) {
      var m = String(p && p[1] || '').match(WK);
      if (m) WEEKS[String(p[0])] = parseInt(m[1], 10);
    });
    dlg.addEventListener('cancel', function (e) { e.preventDefault(); close(); });   // Esc
    dlg.addEventListener('close', function () { // ✕, tło, „Back”, Esc, gest: zdejmij wpis historii
      if (pushed && !fromPop && history.state && history.state.hmPs) { pushed = false; history.back(); }
      pushed = false; fromPop = false;
    });
    dlg.addEventListener('click', function (e) { if (e.target.closest('[data-ps-close]')) { e.preventDefault(); close(); } });
    if (buyBtn) buyBtn.addEventListener('click', function () {
      var b = mainBtn();
      if (!b || b.getAttribute('aria-busy') === 'true' || b.getAttribute('aria-disabled') === 'true') return;
      track('ps_buy');
      // arkusz zamyka się od razu; gdy ma wpis historii, zakup rusza po jego zdjęciu (popstate), awaryjnie po 800 ms
      var viaPop = pushed && history.state && history.state.hmPs;
      buyAfterPop = !!viaPop;
      closing = true; dlg.classList.remove('is-open'); finish();
      if (viaPop) setTimeout(function () { if (buyAfterPop) buy(); }, 800); else buy();
    });
    var head = q('.ps-head');
    if (head) { // telefon: przeciągnięcie uchwytu / nagłówka w dół zamyka
      head.addEventListener('pointerdown', function (e) {
        if (window.innerWidth >= 960 || closing || e.target.closest('[data-ps-close]')) return;
        drag = { y: e.clientY, dy: 0 }; card.classList.add('drag');
        try { head.setPointerCapture(e.pointerId); } catch (x) {}
      });
      head.addEventListener('pointermove', function (e) {
        if (!drag) return; drag.dy = Math.max(0, e.clientY - drag.y); card.style.transform = drag.dy ? 'translateY(' + drag.dy + 'px)' : '';
      });
      var up = function () { if (!drag) return; var dy = drag.dy; drag = null; card.classList.remove('drag'); if (dy > 90) close(); else card.style.transform = ''; };
      head.addEventListener('pointerup', up); head.addEventListener('pointercancel', up);
    }
    return true;
  }

  document.addEventListener('click', function (e) {
    var t = e.target && e.target.closest ? e.target.closest('[data-ps-open],[data-hm-buy],[data-hm-buy-section] .buy .batch') : null;
    if (!t) return;
    if (t.hasAttribute('data-hm-buy')) { // zakup: znacznik do jednego otwarcia po powrocie z kasy
      if (t.getAttribute('aria-busy') !== 'true' && t.getAttribute('aria-disabled') !== 'true' && !t.hasAttribute('data-off')) {
        store(function (s) { s.setItem(GO, location.pathname + '|' + Date.now()); });
      }
      return;
    }
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button === 1) return;
    if (t.hasAttribute('data-ps-open')) { e.preventDefault(); open('link'); return; }
    if (e.target.closest('a,button,input,label,summary')) return;
    open('batch');
  }, true);

  window.addEventListener('popstate', function () {
    if (buyAfterPop) { buy(); return; }
    if (dlg && dlg.open) { fromPop = true; pushed = false; close(); }
  });

  window.addEventListener('pageshow', function (e) {
    var go = store(function (s) { var v = s.getItem(GO); if (v !== null) s.removeItem(GO); return v; });
    if (!init()) return;
    syncPlan();
    if (dlg.open) { if (!locked) lock(); return; }   // bfcache: arkusz był otwarty, zostaje
    try { if (history.state && history.state.hmPs) history.replaceState(null, ''); } catch (x) {} // przeładowany wpis arkusza: bez ponownego otwarcia
    if (!go) return;
    var p = String(go).split('|');
    if (p[0] !== location.pathname || !(Date.now() - (+p[1] || 0) < FRESH)) return;
    var nav = (window.performance && performance.getEntriesByType && performance.getEntriesByType('navigation')[0]) || {};
    if (!e.persisted && nav.type !== 'back_forward') return; // tylko powrót „Wstecz” z kasy, nie nowe wejście na kartę
    if (store(function (s) { return s.getItem(SHOWN); })) return;
    if (e.persisted) open('return');
    else requestAnimationFrame(function () { setTimeout(function () { open('return'); }, 150); }); // po przywróceniu przewinięcia przy przeładowaniu
  });

  document.addEventListener('hm:plan', syncPlan);
  document.addEventListener('shopify:section:load', function () { placeLines(); watchErr(); if (init()) syncPlan(); });

  function watchErr() { // zakup się nie udał (komunikat błędu, bez przejścia do kasy): znacznik powrotu z kasy kasujemy
    var r = hero(), er = r && r.querySelector('[data-buy-err]');
    if (!er || er.hasAttribute('data-ps-watch') || !window.MutationObserver) return;
    er.setAttribute('data-ps-watch', '');
    new MutationObserver(function () { if (!er.hidden) store(function (s) { s.removeItem(GO); }); })
      .observe(er, { attributes: true, attributeFilter: ['hidden'] });
  }

  placeLines();
  watchErr();
  if (init()) syncPlan();
  if (location.hash === '#why-december') {
    open('hash');
    window.addEventListener('load', function () { // fragment URL przenosi fokus na <dialog>; oddaj go tytułowi
      if (dlg && dlg.open && title) { try { title.focus({ preventScroll: true }); } catch (e) {} }
    }, { once: true });
  }
  window.HMPS = { open: function () { open('api'); }, close: close };
})();
